<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white">Please Wait...While Fetching Data</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">Advertise

        <div>
            <button mat-raised-button color="primary" style="font-size: 14px;
                    margin-right: 15px;" (click)="addAd()"><mat-icon>add</mat-icon>Add</button>
        </div>

    </div>
</div>


<div class="mat-elevation-z8" style="margin: 0.5rem;">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
    </mat-form-field>
    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- Position Column -->
            <ng-container matColumnDef="ad_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>ID.</th>
                <td mat-cell *matCellDef="let element"> {{element.ad_id}} </td>
            </ng-container>

            <ng-container matColumnDef="created_by">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created By </th>
                <td mat-cell *matCellDef="let element">{{element.created_by}}</td>
            </ng-container>

            <ng-container matColumnDef="link">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Link </th>
                <td mat-cell *matCellDef="let element">{{element.link}}</td>
            </ng-container>

            <ng-container matColumnDef="is_active">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
                <td mat-cell *matCellDef="let element"> <mat-checkbox [(ngModel)]="element.is_active"
                        (change)="onCheckboxChange(element)">
                    </mat-checkbox></td>
            </ng-container>

            <ng-container matColumnDef="created_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Created Date </th>
                <td mat-cell *matCellDef="let element">{{element.created_date | date:'dd/MM/yyyy'}}</td>
            </ng-container>

            <ng-container matColumnDef="image_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Image </th>
                <td mat-cell *matCellDef="let element">
                    <img src="{{element.image_name}}" style="width: 130px;height: 70px;">
                </td>
            </ng-container>

            <ng-container matColumnDef="action" stickyEnd justify="end">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                <td mat-cell *matCellDef="let element">
                    <button mat-raised-button color="primary" matTooltip="Edit" style="margin-right: 5px;"
                        (click)="Edit_Ad(element.ad_id)">
                        <mat-icon class="m-0">edit</mat-icon>
                    </button>

                    <button mat-raised-button color="warn" matTooltip="Delete" (click)="DeleteAd(element.ad_id)">
                        <mat-icon class=" m-0">delete</mat-icon>
                    </button>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[50, 100, 150, 200]" showFirstLastButtons
        aria-label="Select page of periodic elements">
    </mat-paginator>
</div>